module.exports = __webpack_public_path__ + "static/media/bed_new_pack_dog_FR_285x285.341e0fb3.png";